import React from 'react';
const CART_URL = 'https://instanthandbook.com/en/cart/add?id=44085498708019&quantity=1';
const benefits = [{
  emoji: '📖',
  title: 'Know exactly what to do',
  description: 'The next time your child gets a fever at 2am — without panic, without pills, without a 3am CVS run.'
}, {
  emoji: '🌿',
  title: "Use what's already in your kitchen",
  description: '80% of the remedies in this handbook use ingredients you already own.'
}, {
  emoji: '💊',
  title: 'Stop throwing money at symptoms',
  description: 'Start addressing the root cause with plant-based solutions your body actually recognizes.'
}, {
  emoji: '🧠',
  title: 'Become the person your family turns to',
  description: 'The mom, the partner, the friend who always knows what to do naturally.'
}, {
  emoji: '⚡',
  title: 'Have a lifetime reference guide',
  description: 'Every time you face a new symptom, you open the handbook and the answer is already there.'
}, {
  emoji: '🛡️',
  title: 'Feel confident, not helpless',
  description: 'Because you finally have a system, not just random tips from the internet.'
}];
export function BenefitsSection() {
  return <section className="py-8 md:py-16 bg-primary" data-id="element-18">
      <div className="max-w-5xl mx-auto px-4" data-id="element-19">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-center text-white mb-4" data-id="element-20">
          WHAT YOU'LL BE ABLE TO DO
        </h2>

        <div className="mx-auto w-16 h-1 rounded-full bg-solution mb-6 md:mb-10" data-id="element-21"></div>

        <div className="grid grid-cols-2 gap-2.5 md:gap-4" data-id="element-22">
          {benefits.map((benefit, index) => <div key={index} className="bg-primary-light/30 border border-white/15 rounded-xl p-3 md:p-5 text-center" data-id="element-23">
              <span className="text-3xl md:text-4xl block mb-1.5 md:mb-3" data-id="element-24">
                {benefit.emoji}
              </span>
              <h3 className="font-heading text-base md:text-xl font-bold text-white mb-1 md:mb-2" data-id="element-25">
                {benefit.title}
              </h3>
              <p className="text-white/65 leading-snug text-xs md:text-base" data-id="element-26">
                {benefit.description}
              </p>
            </div>)}
        </div>

        <div className="mt-6 md:mt-10 text-center" data-id="element-27">
          <a href="https://instanthandbook.com/en/cart/add?id=44085498708019&quantity=1" className="inline-block w-full sm:w-auto bg-white hover:bg-gray-50 text-primary font-bold text-lg md:text-xl px-10 py-5 rounded-lg transition-all duration-200 transform hover:scale-[1.01] shadow-xl text-center" data-id="element-28">
            YES — GIVE ME INSTANT ACCESS »
          </a>
          <p className="text-white/50 text-sm mt-4" data-id="element-29">
            $27 one-time · Instant download · 14-day guarantee
          </p>
        </div>
      </div>
    </section>;
}